import { gql } from "apollo-angular";
import ID from "../../types/id";
import SavedExportField from "../../interfaces/saved-export-field";
import AttributeType from "../../interfaces/attribute-type";
import DateType from "../../interfaces/date-type";
import RoleType from "../../interfaces/role-type";
import {PipelineMilestone} from "../../interfaces/pipeline-milestone";


interface SavedExportRequest {
  userId: ID
}
interface SavedExportResponse {
  getSavedExports: SavedExportField[]
}
export const GET_SAVED_EXPORT = gql<SavedExportResponse, SavedExportRequest>`
    query getSavedExports($userId: ID!){
      getSavedExports(user_id: $userId){
        id
        name
        columns
      }
    }
`

interface SpecialFieldValuesResponse {
  attribute_types: AttributeType[],
  date_types: DateType[],
  dealParticipants: RoleType,
  fundParticipants: RoleType,
  milestones: PipelineMilestone[],
  sponsors: RoleType,
}
interface SpecialFieldValuesRequest {}
export const GET_SPECIAL_FIELD_VALUES = gql<SpecialFieldValuesResponse,SpecialFieldValuesRequest>`
    query getSpecialFieldValues{
      attribute_types(active: true){
        id
        name
      }
      date_types(active: true, model: "projects"){
        id
        name
      }
      dealParticipants: roles_by_role_type_name(name: "CREA Project"){
        roles{
          id
          name
        }
      }
      fundParticipants: roles_by_role_type_name(name: "CREA Fund"){
        roles{
          id
          name
        }
      }
      sponsors: roles_by_role_type_name(name: "Deal Sponsor"){
        roles{
          id
          name
        }
      }
      milestones: getPipelineMilestones(onPipeline: "Closing"){
        milestone{
          id
          name
        }
        index
      }
    }
`

export interface CreateSavedExportFieldInput {
  name: string,
  columns: string,
  user_id: ID
}
interface CreateSavedExportFieldResponse {
  createSavedExport: SavedExportField
}
interface CreateSavedExportFieldRequest {
  input: CreateSavedExportFieldInput
}


export const CREATE_SAVED_EXPORT = gql<CreateSavedExportFieldResponse, CreateSavedExportFieldRequest>`
  mutation createSavedExport($input:CreateSavedExportFieldInput!){
    createSavedExport(input:$input){
      id
      user_id
    }
  }
`
export interface SavedExportFieldInput {
  name: string,
  columns: string,
};

interface UpdateSavedExportFieldResponse {
  updateSavedExport: SavedExportField
}
interface UpdateSavedExportFieldRequest {
  id:ID
  input: SavedExportFieldInput
}
export const UPDATE_SAVED_EXPORT = gql<UpdateSavedExportFieldResponse, UpdateSavedExportFieldRequest>`
  mutation updateSavedExport($id: ID!, $input:SavedExportFieldInput!){
    updateSavedExport(id:$id, input:$input){
      id
      user_id
    }
  }
`

interface DeleteSavedExportFieldResponse {
  deleteSavedExport: SavedExportField
}
interface DeleteSavedExportFieldRequest {
  id:ID
}
export const DELETE_SAVED_EXPORT = gql<DeleteSavedExportFieldResponse, DeleteSavedExportFieldRequest>`
  mutation deleteSavedExport($id: ID!){
    deleteSavedExport(id:$id){
      id
      user_id
    }
  }
`
